import WebComponent from "./_web_component";

export default class WCFilter extends WebComponent {
    constructor(el, params) {
        super(el, params)
    }

    init() {
        /* $('.cm-delivery-admin').change((e) => {

        }) */

        const switchs = $(this.element).find('.cm-filter-switch')
        this.selectAdmin = $('.cm-filter-admin').find('select')
        this.selectAsesor = $('.cm-filter-asesor').find('select')

        if (this.selectAdmin.val()) {
            this.toggle(true)
        } else if (this.selectAsesor.val()) {
            switchs.attr('checked', false)
            this.toggle(false)
        }

        switchs.change((e) => {
            if ( $(e.target).is(":checked") ) {
                this.selectAsesor.val('').trigger('change')
                // select.select2('val', '');
                this.toggle(true)
            } else {
                this.selectAdmin.val('').trigger('change')
                this.toggle(false)
            }
        })
    }

    toggle(sw){
        this.selectAdmin.attr('disabled', !sw)
        this.selectAsesor.attr('disabled', sw)
    }
}
